export const SET_ENABLED_FEATURES = 'SET_ENABLED_FEATURES';

export function setEnabledFeatures(features) {
  return {
    type: SET_ENABLED_FEATURES,
    features,
  };
}
